import { cn } from '@/lib/shadcn/lib/utils';

export function Vkontakte({ className }: { className?: string }) {
  return (
    <svg
      className={cn('size-full', className)}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14 10.7491V7.0531C14 6.2201 13.849 6.0531 13.02 6.0531L10.67 6.0001C9.93803 6.0001 9.57203 6.0001 9.42403 6.2371C9.27603 6.4741 9.44003 6.7991 9.76703 7.4471C9.94903 7.8071 10.047 8.0681 10.047 8.4721V11.1321C10.047 11.9721 10.047 12.3931 9.72703 12.5181C9.40703 12.6421 9.14203 12.3601 8.61003 11.7961C7.31003 10.4121 6.63203 8.6841 6.18703 6.8001C6.09503 6.4101 6.04903 6.2151 5.91103 6.1071C5.77303 5.9991 5.57603 6.0001 5.18403 6.0001H2.98403C2.50203 6.0001 2.26103 6.0001 2.11003 6.1701C1.96003 6.3411 1.98903 6.5591 2.04703 6.9941C2.57503 10.9211 6.02803 17.3601 12.407 17.9741C13.537 18.0821 14 17.7771 14 16.5391C14 15.8371 13.985 14.7031 14.868 14.5541C15.331 14.4761 15.642 14.6411 16.159 15.0741C17.055 15.8261 17.525 16.7441 17.852 17.4411C18.069 17.9031 18.23 18.0001 18.74 18.0001H20.814C21.862 18.0001 22.147 17.7441 21.68 16.7601C21.1522 15.6565 20.405 14.6722 19.484 13.8671C18.848 13.3201 18.531 13.0471 18.514 12.8451C18.495 12.6441 18.728 12.3591 19.194 11.7891C20.094 10.6871 21.32 8.9581 21.892 7.1231C22.176 6.2131 21.909 6.0001 20.988 6.0001H19.125C18.222 6.0001 18.223 5.9691 18.01 6.9931C17.664 8.6541 16.532 10.2511 15.468 11.3381C14.963 11.8541 14.658 12.1651 14.343 12.0381C14.028 11.9111 14 11.5251 14 10.7491Z"
        stroke="currentColor"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
